import { OauthAEMConfig } from './config.interfaces';
import { Errors, PingFederateError } from './errors.interfaces';

export interface LoginOAuth {
  id?: string;
  pluginTypeId?: string;
  rememberMyUsernameSelected?: boolean;
  showCaptcha?: false;
  showRememberMyUsername?: boolean;
  showThisIsMyDevice?: boolean;
  status?: string;
  thisIsMyDeviceSelected?: boolean;
  authorizeResponse?: AuthorizeResponse;
  error?: PingFederateError;
  errors?: Errors[];
  code?: string;
  error_description?: string;
}

export interface IssuerEnv {
  [key: string]: string;
}

export interface PkceCode {
  codeChallenge: string;
  codeVerifier: string;
}

export interface AuthorizeResponse {
  code: string;
  state?: string;
}

export interface ILoginUserNamePasswordInput {
  userName: string;
  password: string;
  lastName?: string;
  rememberMe?: string;
  persistentLogin?: string;
}

export interface LoginOAuthParams {
  oauthConfig: OauthAEMConfig;
  pkceCode: PkceCode;
  redirectfulFlowId?: string;
  prompt?: string;
  persistentCookie?: string;
}

export interface CheckForRedirectfulAuthCall {
  redirectfulFlowId: string;
  refreshUrl: string;
}

export interface RememberMeDetails {
  encyToken: string | undefined;
  uid: string | undefined;
}
